import {
  Autocomplete,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  useMediaQuery,
  Fab,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DescriptionIcon from "@mui/icons-material/Description";
import styles from "./styles.module.css";
import React, { useEffect, useState, useCallback } from "react";
import { Dialog } from "@mui/material";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { debounce } from "lodash";
import TableRelatorio from "./TableRelatorio";
import {
  buscarProcessos,
  buscarProcessosPorTexto,
  inserirImportacaoSped,
} from "../../services/api-importacoes.service";
import { keyframes } from "@emotion/react";
import { buscarComboPorCodigo } from "../../services/auth.service";
import GenericDatePicker from "../../components/GenericDatePicker";
import WhiteButton from "../../components/WhiteButton";
import BlueButton from "../../components/BlueButton";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import { getSocket } from "../../utils/webSocket.util";
import Loading from "../../components/Loading";
import { apiNoAr } from "../../services/api-rpa.service";

const styleAutoComplete = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
    fontSize: "1.1rem",
    "& fieldset": {
      borderColor: "#18316e",
    },
    "&:hover fieldset": {
      borderColor: "#18316e",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#18316e",
    },
    "& input": {
      fontSize: "1.1rem",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "1.1rem",
  },
};

const ImportarSpeds = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openModalDetalhes, setOpenModalDetalhes] = useState(false);
  const [tipoSped, setTipoSped] = useState({ content: null, error: false });
  const [codigoRelatorio, setCodigoRelatorio] = useState("");
  const minDesktop = useMediaQuery("(max-width: 900px)");
  const [pesquisa, setPesquisa] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [carregamentoInicial, setCarregamentoInicial] = useState(true);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [hasSchema, setHasSchema] = useState(false);
  const [listaGruposEconomicos, setListaGruposEconomicos] = useState([]);
  const [grupoSelecionado, setGrupoSelecionado] = useState(null);
  const [schemas, setSchemas] = useState([]);
  const [dtInicial, setDtInicial] = useState({ content: null, error: false });
  const [dtFinal, setDtFinal] = useState({
    content: null,
    error: false,
    helperText: null,
  });
  const [schemasSelected, setSchemasSelected] = useState([]);
  const [grupoError, setGrupoError] = useState(false);
  const [schemaError, setSchemaError] = useState(false);
  const listaTiposSped = [
    { value: "contribuicoes", label: "Contribuições" },
    { value: "contabil", label: "Contábil" },
    { value: "ecf", label: "ECF" },
    { value: "fiscal", label: "Fiscal" },
  ];
  const [msg, setMsg] = useState("");
  const [objImportador, setObjImportador] = useState({});

  const obterDataHoje = () => {
    const hoje = new Date();
    const ano = hoje.getFullYear();
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    const dia = String(hoje.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  // Extrair filtros dos selectedOptions
  const extrairFiltros = () => {
    const filtros = {
      tipo: null,
      status: null,
      cnpj: null
    };
    
    selectedOptions.forEach((option) => {
      const value = option.value;
      if (value.startsWith('tipo: ')) {
        filtros.tipo = value.replace('tipo: ', '').trim();
      } else if (value.startsWith('status: ')) {
        filtros.status = value.replace('status: ', '').trim();
      }
    });
    
    // Se houver pesquisa, pode ser CNPJ
    if (pesquisa && pesquisa.trim() !== '') {
      const cnpjMatch = pesquisa.replace(/\D/g, '');
      if (cnpjMatch.length >= 8) {
        filtros.cnpj = pesquisa;
      }
    }
    
    return filtros;
  };

  const handleDadosIniciais = async (resetPage = false) => {
    try {
      setLoading(true);
      
      // Extrair filtros dos selectedOptions
      const filtros = extrairFiltros();
      const temFiltros = filtros.tipo || filtros.status || filtros.cnpj || pesquisa.trim() !== '';
      
      // Se não houver filtros, aplicar data atual
      // Se houver filtros, não aplicar data atual
      const dataFiltro = temFiltros ? null : obterDataHoje();
      
      // Resetar página se necessário
      const currentPage = resetPage ? 1 : page;
      
      console.log('[ImportarSpeds] handleDadosIniciais - Parâmetros:', {
        dataFiltro,
        filtros,
        temFiltros,
        currentPage,
        limit
      });
      
      const response = await buscarProcessos(dataFiltro, filtros, currentPage, limit);
      
      console.log('[ImportarSpeds] handleDadosIniciais - Resposta:', {
        processosCount: response.processos?.length || 0,
        pagination: response.pagination,
        total: response.pagination?.total || 0
      });
      
      const dadosOrganizados = handleOrganizaDados(response.processos || []);
      setData(dadosOrganizados);
      setFilteredData(dadosOrganizados);
      
      // Atualizar contagem e paginação
      if (response.pagination) {
        const totalValue = response.pagination.total || 0;
        console.log('[ImportarSpeds] Atualizando total:', totalValue);
        setTotal(totalValue);
        setPage(response.pagination.page || currentPage);
      } else {
        // Fallback para compatibilidade
        const fallbackTotal = response.processos?.length || 0;
        console.log('[ImportarSpeds] Usando fallback total:', fallbackTotal);
        setTotal(fallbackTotal);
      }

      const queryParams = new URLSearchParams(window.location.search);
      const id = queryParams.get("id");

      if (id && response.processos) {
        const processo = response.processos.find(
          (item) => item.id_fila_importacao_sped === parseInt(id)
        );
        if (processo) {
          const objDetalhes = {
            cnpj: processo.cnpj,
            detalhes: processo.detalhes,
            dt_fim_processo: new Date(processo.dt_fim_processo)
              .toLocaleString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
              .replace(",", ""),
            dt_fim_sped: `${processo.dt_fim_sped.split("-")[2]}/${
              processo.dt_fim_sped.split("-")[1]
            }/${processo.dt_fim_sped.split("-")[0]}`,
            dt_inicio_processo: new Date(processo.dt_inicio_processo)
              .toLocaleString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
              .replace(",", ""),
            dt_inicio_sped: `${processo.dt_inicio_sped.split("-")[2]}/${
              processo.dt_inicio_sped.split("-")[1]
            }/${processo.dt_inicio_sped.split("-")[0]}`,
            status: processo.status,
            tipoSped: processo.tipo_sped,
            usuario: processo.usuario,
          };
          handleOpenModalDetalhes(objDetalhes);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect para carregar dados iniciais quando a tela carrega
  useEffect(() => {
    // Ao carregar a tela inicialmente, SEMPRE buscar apenas arquivos do dia (sem filtros)
    // Este useEffect só roda uma vez quando o componente é montado
    if (carregamentoInicial) {
      console.log('[ImportarSpeds] Carregamento inicial - chamando handleDadosIniciais');
      handleDadosIniciais(false);
      setCarregamentoInicial(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect para quando a URL mudar (ex: quando há um ?id=xxx)
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    
    // Se houver um ID na URL, recarregar dados mantendo os filtros atuais
    if (id && !carregamentoInicial) {
      const temFiltros = selectedOptions.length > 0 || pesquisa.trim() !== "";
      handleDadosIniciais(temFiltros);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);

  // useEffect para quando filtros ou pesquisa mudarem
  useEffect(() => {
    // Só executar se não for o carregamento inicial
    if (!carregamentoInicial) {
      // Quando os filtros de seleção ou pesquisa mudarem, recarregar dados
      // Resetar página quando filtros mudarem
      handleDadosIniciais(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions, pesquisa]);

  const handleOrganizaDados = (dados) => {
    const novosDados = dados.map((item) => {
      return {
        cnpj: item.cnpj,
        tipoSped: item.tipo_sped,
        status: item.status,
        usuario: item.usuario,
        dt_inicio_processo: new Date(item.dt_inicio_processo)
          .toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })
          .replace(",", ""),
        dt_fim_processo: new Date(item.dt_fim_processo)
          .toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })
          .replace(",", ""),
        dt_inicio_sped: `${item.dt_inicio_sped.split("-")[2]}/${
          item.dt_inicio_sped.split("-")[1]
        }/${item.dt_inicio_sped.split("-")[0]}`,
        dt_fim_sped: `${item.dt_fim_sped.split("-")[2]}/${
          item.dt_fim_sped.split("-")[1]
        }/${item.dt_fim_sped.split("-")[0]}`,
        detalhes: item.detalhes,
      };
    });
    return novosDados;
  };

  // Função removida - filtros agora são aplicados no backend

  const extractText = (value) => {
    if (typeof value === "string") {
      return value;
    } else if (React.isValidElement(value)) {
      let extractedString = "";
      React.Children.forEach(value.props.children, (child) => {
        if (typeof child === "string") {
          extractedString += child;
        } else if (React.isValidElement(child)) {
          React.Children.forEach(child.props.children, (nestedChild) => {
            if (typeof nestedChild === "string") {
              extractedString += nestedChild;
            }
          });
        }
      });
      return extractedString.trim();
    }
    return "";
  };

  const handleFilter = (_, value) => {
    const mapValue = value.map((item) => {
      if (item.value.includes(":")) {
        const splitValue = item.value.split(":");
        return { value: splitValue[1].trim() };
      } else {
        return { value: item.value };
      }
    });

    setSelectedOptions(mapValue);
  };

  const isOptionEqualToValue = (option, value) => {
    const [_, optionValue] = option.value.split(":").map((s) => s.trim());
    return optionValue === value.value;
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        const listaGrupos = await handleRenderListAutoComplete(
          "GRUPOECONOMICO"
        );
        setListaGruposEconomicos(listaGrupos);
        setHasSchema(true);
      } catch (error) {
        console.log(error);
      }
    };
    if (openModal) fetch();
  }, [openModal, codigoRelatorio]);

  useEffect(() => {
    const fetchData = async () => {
      const empresas = await handleRenderListAutoComplete(
        `EMPRESA_POR_GRUPO_${grupoSelecionado?.id}`
      );
      setSchemas(empresas);
    };
    grupoSelecionado ? fetchData() : setSchemas([]);
  }, [grupoSelecionado]);

  const atualizarTabela = async () => {
    try {
      const filtros = extrairFiltros();
      const temFiltros = filtros.tipo || filtros.status || filtros.cnpj || pesquisa.trim() !== '';
      const dataFiltro = temFiltros ? null : obterDataHoje();
      
      console.log('[ImportarSpeds] atualizarTabela - Parâmetros:', {
        dataFiltro,
        filtros,
        temFiltros,
        page,
        limit
      });
      
      const response = await buscarProcessos(dataFiltro, filtros, page, limit);
      
      console.log('[ImportarSpeds] atualizarTabela - Resposta:', {
        processosCount: response.processos?.length || 0,
        pagination: response.pagination,
        total: response.pagination?.total || 0
      });
      
      const dadosOrganizados = handleOrganizaDados(response.processos || []);
      setData(dadosOrganizados);
      setFilteredData(dadosOrganizados);
      
      // Atualizar contagem e paginação
      if (response.pagination) {
        const totalValue = response.pagination.total || 0;
        console.log('[ImportarSpeds] atualizarTabela - Atualizando total:', totalValue);
        setTotal(totalValue);
        setPage(response.pagination.page || page);
      } else {
        const fallbackTotal = response.processos?.length || 0;
        console.log('[ImportarSpeds] atualizarTabela - Usando fallback total:', fallbackTotal);
        setTotal(fallbackTotal);
      }
    } catch (error) {
      console.error('[ImportarSpeds] atualizarTabela - Erro:', error);
    }
  };

  // useEffect(() => {
  //   getSocket().on("atualizar-tabela-sped-insert", () => {
  //     atualizarTabela();
  //   });
  //   getSocket().on("atualizar-tabela-sped-update", () => {
  //     atualizarTabela();
  //   });
  // }, []);

  const handleOpenModal = async () => {
    //  Verificar se a api Python está no ar
    if (!(await apiNoAr())) {
      setMsg("O RPA está fora do ar, fale com a T.I");
      setOpenSnackErro(true);
      return;
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setGrupoSelecionado(null);
    setSchemasSelected([]);
    setTipoSped({ content: null, error: false });
    setDtInicial({ content: null, error: false });
    setDtFinal({ content: null, error: false, helperText: null });
    setSchemaError(false);
    setGrupoError(false);
    setOpenModal(false);
  };

  const handleOpenModalDetalhes = (dados) => {
    console.log(dados);

    setObjImportador(dados);
    setOpenModalDetalhes(true);
  };

  const handleCloseModalDetalhes = () => {
    setOpenModalDetalhes(false);
  };

  const [openSnackSucesso, setOpenSnackSucesso] = useState(false);
  const [openSnackErro, setOpenSnackErro] = useState(false);

  const handleCloseSnackSucesso = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackSucesso(false);
  };
  const handleCloseSnackErro = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackErro(false);
  };

  const handleRenderListAutoComplete = async (codCombo) => {
    const response = await buscarComboPorCodigo(codCombo);
    const combosFormat = response.detalhes.itensCombo
      .filter((item) => item)
      .map((item) => {
        const split = item.split("/|/");
        return {
          id: split[0],
          detalhes: split[1],
        };
      });

    return combosFormat;
  };

  const handlePesquisaPorTexto = async (textoDeBusca) => {
    try {
      if (textoDeBusca && textoDeBusca.trim() !== '') {
        // Quando há pesquisa por texto, buscar todos os processos (sem filtro de data)
        const response = await buscarProcessosPorTexto(textoDeBusca, 1, limit);
        const dadosOrganizados = handleOrganizaDados(response.processos || []);
        setData(dadosOrganizados);
        setFilteredData(dadosOrganizados);
        
        // Atualizar contagem e paginação
        if (response.pagination) {
          setTotal(response.pagination.total);
          setPage(1);
        }
      } else {
        // Quando não há pesquisa, voltar para a regra padrão
        handleDadosIniciais(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeSchema = (value) => {
    setSchemasSelected(value);
    if (!value) setSchemaError(true);
    else setSchemaError(false);
  };

  const handleChangeValue = (name, value) => {
    switch (name) {
      case "tipoSped":
        setTipoSped({ content: value, error: value != null ? false : true });
        break;
      case "dtInicial":
        setDtInicial({ content: value, error: value != null ? false : true });
        break;
      case "dtFinal":
        if (dtInicial.content > value) {
          setDtFinal({
            content: value,
            error: true,
            helperText: "A data final é menor que a inicial",
          });
        } else if (value > new Date()) {
          setDtFinal({
            content: value,
            error: true,
            helperText: "A data final não pode ser maior que a data de hoje",
          });
        } else {
          setDtFinal({
            content: value,
            error: value != null ? false : true,
            helperText: null,
          });
        }
        break;
      default:
        break;
    }
  };

  const handleSubmitInsert = async (e) => {
    e.preventDefault();

    setLoading(true);

    if (schemasSelected.length === 0) setSchemaError(true);
    if (!grupoSelecionado) setGrupoError(true);
    if (!tipoSped.content) tipoSped.error = true;
    if (!dtInicial.content) dtInicial.error = true;
    if (!dtFinal.content) dtFinal.error = true;

    if (
      grupoError ||
      schemaError ||
      schemasSelected.length === 0 ||
      !grupoSelecionado ||
      tipoSped.error ||
      dtInicial.error ||
      dtFinal.error
    ) {
      setMsg("Preencha todos os campos obrigatórios.");
      setOpenSnackErro(true);
      return;
    }
    const cnpj = schemasSelected.id;
    const dtInicialFormatada = new Date(dtInicial.content)
      .toISOString()
      .slice(0, 10);
    const dtFinalFormatada = new Date(dtFinal.content)
      .toISOString()
      .slice(0, 10);

    //  Chamar API do RPA

    try {
      const responseImport = await inserirImportacaoSped({
        cnpj,
        tipoSped: tipoSped.content.value,
        dtInicioSped: dtInicialFormatada,
        dtFimSped: dtFinalFormatada,
      });
      await handleDadosIniciais(true)
      setMsg(responseImport?.mensagem);
      setOpenSnackSucesso(true);
    } catch (error) {
      console.log(error);
      setMsg("Erro interno na API Importação. Contate a equipe de suporte.");
      setOpenSnackErro(true);
    } finally {
      setLoading(false);
    }

    handleCloseModal();

    //  Web socket para atualizar tabela
    // getSocket().emit("atualizar-tabela-sped-server-insert");
  };

  const debouncedHandleChangeSearchText = useCallback(
    debounce(handlePesquisaPorTexto, 1000),
    []
  );

  const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

  return (
    <>
      {loading ? (
        <Loading loading={loading} />
      ) : (
        <>
          <Paper className={styles.container}>
            {/* Header */}
            <div className={styles.header}>
              <div className={styles.title}>
                <ImportExportIcon sx={{ marginRight: "1rem" }} />
                Importador de SPEDs
              </div>

              <div className={styles.filtrosContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={7}>
                    <Autocomplete
                      value={selectedOptions}
                      sx={styleAutoComplete}
                      multiple
                      id="tags-outlined"
                      isOptionEqualToValue={isOptionEqualToValue}
                      options={[
                        { value: "tipo: Contribuições" },
                        { value: "tipo: Contábil" },
                        { value: "tipo: ECF" },
                        { value: "tipo: Fiscal" },
                        { value: "status: Sucesso" },
                        { value: "status: Erro" },
                        { value: "status: Processando" },
                        { value: "status: Aguardando na fila" },
                      ]}
                      getOptionLabel={(option) => option.value}
                      onChange={handleFilter}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          variant="outlined"
                          label="Filtrar por..."
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      sx={styleAutoComplete}
                      label="Buscar por campos..."
                      id="outlined-start-adornment"
                      onChange={(e) => {
                        debouncedHandleChangeSearchText(e.target.value);
                        setPesquisa(e.target.value);
                      }}
                      value={pesquisa}
                      fullWidth
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon sx={{ color: "#18316e" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
            {/* Visualização */}
            <Paper className={styles.visualizacaoContainer}>
              <TableRelatorio
                data={filteredData}
                handleOpenModalDetalhes={handleOpenModalDetalhes}
              />
              <div style={{ 
                borderTop: '1px solid #e0e0e0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 16px',
                flexWrap: 'wrap',
                gap: '16px'
              }}>
                <TablePagination
                  component="div"
                  count={total}
                  page={page - 1}
                  onPageChange={async (event, newPage) => {
                    const newPageNum = newPage + 1;
                    setPage(newPageNum);
                    
                    // Recarregar dados com a nova página
                    try {
                      setLoading(true);
                      const filtros = extrairFiltros();
                      const temFiltros = filtros.tipo || filtros.status || filtros.cnpj || pesquisa.trim() !== '';
                      const dataFiltro = temFiltros ? null : obterDataHoje();
                      
                      const response = await buscarProcessos(dataFiltro, filtros, newPageNum, limit);
                      const dadosOrganizados = handleOrganizaDados(response.processos || []);
                      setData(dadosOrganizados);
                      setFilteredData(dadosOrganizados);
                      
                      if (response.pagination) {
                        setTotal(response.pagination.total);
                      }
                    } catch (error) {
                      console.log(error);
                    } finally {
                      setLoading(false);
                    }
                  }}
                  rowsPerPage={limit}
                  onRowsPerPageChange={async (event) => {
                    const newLimit = parseInt(event.target.value, 10);
                    setLimit(newLimit);
                    setPage(1);
                    
                    // Recarregar dados com o novo limite
                    try {
                      setLoading(true);
                      const filtros = extrairFiltros();
                      const temFiltros = filtros.tipo || filtros.status || filtros.cnpj || pesquisa.trim() !== '';
                      const dataFiltro = temFiltros ? null : obterDataHoje();
                      
                      const response = await buscarProcessos(dataFiltro, filtros, 1, newLimit);
                      const dadosOrganizados = handleOrganizaDados(response.processos || []);
                      setData(dadosOrganizados);
                      setFilteredData(dadosOrganizados);
                      
                      if (response.pagination) {
                        setTotal(response.pagination.total);
                      }
                    } catch (error) {
                      console.log(error);
                    } finally {
                      setLoading(false);
                    }
                  }}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  labelRowsPerPage="Linhas por página:"
                  labelDisplayedRows={({ from, to, count }) => {
                    const totalText = count !== -1 ? Number(count).toLocaleString("pt-BR") : `mais de ${to}`;
                    return `${from}-${to} de ${totalText}`;
                  }}
                  sx={{
                    flex: 1,
                    '.MuiTablePagination-toolbar': {
                      paddingLeft: 0,
                      paddingRight: 0,
                    },
                    '.MuiTablePagination-displayedRows': {
                      margin: '0 16px 0 auto',
                      fontWeight: 500,
                    }
                  }}
                />
                <div style={{ 
                  fontSize: '0.875rem', 
                  fontWeight: 600, 
                  color: '#18316e',
                  whiteSpace: 'nowrap',
                  marginLeft: '16px',
                  minWidth: '150px'
                }}>
                  Total: <strong style={{ fontSize: '1rem' }}>{(total || 0).toLocaleString("pt-BR")}</strong> {(total || 0) === 1 ? 'registro' : 'registros'}
                </div>
              </div>
            </Paper>
          </Paper>
          <Fab
            sx={{
              background: "#4b6fc0",
              bottom: 40, // Ajuste a distância da borda inferior
              right: 20, // Ajuste a distância da borda direita
              position: "fixed",
              zIndex: 1000, // Valor alto para garantir que fique acima de outros elementos
              animation: `${pulse} 1.5s infinite ease-in-out`,
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
            aria-label="add"
            onClick={() => {
              handleOpenModal();
            }}
          >
            <AddIcon className={styles.iconeAdd} />
          </Fab>
        </>
      )}
      <Dialog fullWidth open={openModal} onClose={handleCloseModal}>
        <DialogTitle>
          <h4 className={styles.titulosConfirmacao}>
            Inserir nova importação de Sped
          </h4>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <Loading loading={loading} />
          ) : (
            <form onSubmit={handleSubmitInsert}>
              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    fullWidth
                    options={listaGruposEconomicos || []}
                    getOptionLabel={(option) => option.detalhes}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    sx={{ marginTop: "1rem", width: "100%" }}
                    onChange={(_, value) => {
                      setGrupoSelecionado(value);
                      if (value) setGrupoError(false);
                      else setGrupoError(true);
                    }}
                    renderInput={(params) => (
                      <TextField
                        error={grupoError}
                        {...params}
                        label={`Grupo Econômico`}
                      />
                    )}
                  />
                  {schemas.length > 0 ? (
                    <Autocomplete
                      options={schemas}
                      getOptionLabel={(option) => option.detalhes}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      sx={{ marginTop: "1rem", width: "100%" }}
                      onChange={(_, value) => handleChangeSchema(value)}
                      renderInput={(params) => (
                        <TextField
                          error={schemaError}
                          {...params}
                          label={`Empresas`}
                        />
                      )}
                    />
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    sx={{ marginTop: "1rem" }}
                    options={listaTiposSped}
                    value={tipoSped.content}
                    onChange={(_, value) =>
                      handleChangeValue("tipoSped", value)
                    }
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        error={tipoSped.error}
                        {...params}
                        label="Tipo de Sped"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <GenericDatePicker
                    key={"dtInicial"}
                    label={`Data Inicial`}
                    value={dtInicial}
                    name="inputDtInicial"
                    error={dtInicial.error}
                    onChange={(value) => handleChangeValue("dtInicial", value)}
                    sx={{ marginTop: "1rem" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <GenericDatePicker
                    key={"dtFinal"}
                    label={`Data Final`}
                    value={dtFinal}
                    name="inputDtFinal"
                    error={dtFinal.error}
                    helperText={dtFinal.helperText}
                    onChange={(value) => handleChangeValue("dtFinal", value)}
                    sx={{ marginTop: "1rem" }}
                  />
                </Grid>
              </Grid>
              <DialogActions
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <WhiteButton
                  clickFunction={handleCloseModal}
                  textValue="Cancelar"
                  contentIcon={<CloseIcon />}
                  iconLeft
                />
                <BlueButton
                  clickFunction={handleSubmitInsert}
                  textValue="Inserir"
                  type="submit"
                  contentIcon={
                    <SendIcon sx={{ marginLeft: "0.5rem", color: "white" }} />
                  }
                />
              </DialogActions>
            </form>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        fullWidth
        open={openModalDetalhes}
        onClose={handleCloseModalDetalhes}
      >
        <DialogTitle>
          <h4 className={styles.titulosConfirmacao}>Detalhes da importação</h4>
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              marginTop: "1.5rem",
              marginBottom: "0.5rem",
            }}
          >
            <div className={styles.textoDetalhes}>
              <span className={styles.spanDetalhes}>Cnpj:</span>{" "}
              {objImportador?.cnpj}
            </div>
            <div className={styles.textoDetalhes}>
              <span className={styles.spanDetalhes}>Status:</span>{" "}
              {objImportador?.status}
            </div>
            <div className={styles.textoDetalhes}>
              <span className={styles.spanDetalhes}>Detalhe:</span>{" "}
              {objImportador?.detalhes}
            </div>
            <div className={styles.textoDetalhes}>
              <span className={styles.spanDetalhes}>Tipo:</span>{" "}
              {objImportador?.tipoSped}
            </div>
            <div className={styles.textoDetalhes}>
              <span className={styles.spanDetalhes}>Processo iniciou em:</span>{" "}
              {objImportador?.dt_inicio_processo}
            </div>
            <div className={styles.textoDetalhes}>
              <span className={styles.spanDetalhes}>Processo terminou em:</span>{" "}
              {objImportador?.dt_fim_processo}
            </div>
          </div>
          <DialogActions sx={{ justifyContent: "space-between" }}>
            <WhiteButton
              clickFunction={handleCloseModalDetalhes}
              textValue="Fechar"
              contentIcon={<CloseIcon />}
              iconLeft
            />
            <BlueButton
              clickFunction={() => {
                // TODO: Implementar visualização de logs
                console.log("Visualizar logs", objImportador);
              }}
              textValue="Visualizar logs"
              contentStartIcon={<DescriptionIcon />}
            />
          </DialogActions>
        </DialogContent>
      </Dialog>
      <MensagemSucesso
        open={openSnackSucesso}
        msg={msg}
        handleClose={handleCloseSnackSucesso}
      />
      <MensagemErro
        open={openSnackErro}
        msg={msg}
        handleClose={handleCloseSnackErro}
      />
    </>
  );
};

export default ImportarSpeds;
